import { postRequest } from '@/core';
import { savedOrderSearches } from '@/requests';

export default async function newSavedOrderSearchesRequest(savedSearch) {
	let url = savedOrderSearches.getPath();
	let response = await postRequest(url, {},  savedSearch);
	return response;
}
